<ion-grid>
  <ion-row class="ion-justify-content-center">
    <ion-col size="12" size-md="8">

      <ion-card>
        <ion-item lines="full" color="light">
          <ion-icon slot="start" color="primary" name="today-outline"></ion-icon>
          <ion-label>{{"MENU.CHANGELOG" | translate}}</ion-label>
        </ion-item>
        <ion-card-content>
          @for (changelog of changelogs | slice:0:(showAll ? changelogs.length : slice); track changelog; let last = $last) {
            <ion-row>
              @if (changelog.title) {
                <ion-label style="font-size:large">{{ changelog.title }}</ion-label>
              }
              @if (changelog.version) {
                <ion-label style="font-size:large">
                  Version {{ changelog.version }}
                </ion-label>
              }
            </ion-row>
            <ion-row>
              <ul>
                @for (change of changelog.changes; track change) {
                  @if (change.hasOwnProperty('roleIsAtLeast')) {
                    <!-- Limited to 'roleIsAtLeast' -->
                    @if ((service.metadata | async)?.user; as user) {
                      @if (roleIsAtLeast(user.globalRole, change.roleIsAtLeast)) {
                        <li>
                          <span [innerHtml]="change.change"></span>
                          <span style="color: darkgray"><i> (Dieser Eintrag ist nur sichtbar für '{{
                            numberToRole(change['roleIsAtLeast'])
                          }}')</i></span>
                        </li>
                      }
                    }
                  } @else {
                    <!-- Default changelog entry -->
                    <li [innerHtml]="change"></li>
                  }
                }
              </ul>
            </ion-row>
            @if (!last) {
<div style="border-bottom: 1px solid lightgray; width: 110%; margin-top: 2%; margin-bottom: 2%; margin-left:
                -5%;">
              </div>
            }
          }
          @if (changelogs.length > slice && !showAll) {
            <ion-row>
              <ion-col>
                <ion-item lines="none" class="ion-float-right">
                  <ion-button (click)="showAll = true">
                    Alle anzeigen
                  </ion-button>
                </ion-item>
              </ion-col>
            </ion-row>
          }
        </ion-card-content>
      </ion-card>
    </ion-col>
  </ion-row>
</ion-grid>
